import React from 'react';

import { DashboardActionsType } from 'api/CompeonReverseApi/customer/queryHooks/inquiries';

import { FileUploadAction } from './FileUploadAction';
import { ProgressIndicativeOffer } from './ProgressIndicativeOffer';
import ProgressSectionsWrapper from './ProgressSectionsWrapper';
import { ProgressSuccess } from './ProgressSuccess';
import { NewSignContractStep } from './SignContractStep/NewSignContractStep';
import SummaryCard from './SummaryCard';
import SummaryHeader from './SummaryHeader';
import { mapDashboardActionAttributes, useActionCalculations } from './useDashboardActions';

export type DashboardActionProps = {
  completedValue: number;
  isCompleted: boolean;
  isFirst: boolean;
  isLast: boolean;
  isPending: boolean;
  progressIncrement: number;
  progressTotal: number;
  data: any;
  id: string;
  state: string;
};

export const DashboardAction = ({
  type,
  dashboardActionProps,
}: {
  type: string;
  dashboardActionProps: DashboardActionProps;
}) => {
  switch (type) {
    case DashboardActionsType.FILE_UPLOAD:
      return <FileUploadAction {...dashboardActionProps} />;
    case DashboardActionsType.LEGAL_REP_SIGNATURE_PROCESS:
      return <NewSignContractStep {...dashboardActionProps} />;
    case DashboardActionsType.SHOW_INDICATIVE_CONDITIONS:
      return <ProgressIndicativeOffer {...dashboardActionProps} />;
    default:
      return null;
  }
};

const NewCustomerDashboard = () => {
  const {
    actionsDone,
    firstOpenTask,
    completedValue,
    isLoading: dashboardActionsIsLoading,
    dashboardActions,
    progressTotal,
    isCompleted,
    canShowProgress,
    isLastItem,
  } = useActionCalculations();

  const header = (
    <>
      <SummaryHeader />
      <SummaryCard
        completedValue={completedValue}
        progressIncrement={actionsDone}
        progressTotal={progressTotal}
        isCompleted={isCompleted}
        openTaskId={firstOpenTask}
        canShowProgress={canShowProgress}
      />
    </>
  );

  const progressSections = (
    <>
      {dashboardActions.map((action, index) => (
        <DashboardAction
          key={action.id}
          type={action.type}
          dashboardActionProps={{
            ...mapDashboardActionAttributes(action, index),
            isPending: dashboardActionsIsLoading,
            isLast: isLastItem(index),
          }}
        />
      ))}
      {isCompleted && (
        <ProgressSuccess
          isLast
          isCompleted
          completedValue={100}
          progressIncrement={1}
          progressTotal={1}
        />
      )}
    </>
  );

  return (
    <ProgressSectionsWrapper
      header={header}
      progressSections={progressSections}
      isLoading={dashboardActionsIsLoading}
    />
  );
};

export default NewCustomerDashboard;
